import smoothscroll from "smoothscroll-polyfill";
import SmoothScroll from "smooth-scroll";

export function shop() {
  const scroll = new SmoothScroll(null, {
    header: "#header",
    speed: 500,
    speedAsDuration: true,
    easing: 'easeInOutCubic',
  });

  const shops = document.querySelectorAll('.js-shop');

  const listOpen = (shop, btn, items) => {
    shop.classList.add('is-active');
    btn.classList.add('is-active');

    items.forEach(item => {
      item.classList.remove('displayNone');
    });
  }

  const listClose = (shop, btn, items) => {
    shop.classList.remove('is-active');
    btn.classList.remove('is-active');

    items.forEach((item, index) => {
      if(1 < index) {
        item.classList.add('displayNone');
      }
    });
  }

  shops.forEach(shop => {
    const btn = shop.querySelector('.js-shopBtn');
    const list = shop.querySelector('.js-shopList');
    const items = Array.from(list.children);

    btn.addEventListener('click', () => {
      if(shop.classList.contains('is-active')) {
        listClose(shop, btn, items);
        scroll.animateScroll(shop);
      } else {
        listOpen(shop, btn, items);
      }
    })
  });
}